
<!-- section start -->
<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="state__sec">
                    <ul class="state__list" *ngFor="let data of campus?.campusCctvDetails ">
                        <li>
                            <div class="statelist__flex">
                                <div class="statetitle__flex">
                                    <div>
                                        <h5 class="state__name">{{data.buildingName}}
                                        </h5>
                                    </div>
                                    <div>
                                        <h6 class="state__dvrs">DVR Checked : <span class="dvr__color"></span>{{data.dvrCheckDate}}
                                        </h6>
                                    </div>
                                </div>
                                <div class="">
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <div class="card-head" id="headingOne">
                                                <div class="statelist__flexx collapsed" data-toggle="collapse"
                                                    data-target="#collapseOne" aria-expanded="false"
                                                    aria-controls="collapseOne">
                                                    <div class="cctv__collapse">
                                                        <div class="dvr__border__right">
                                                            <h6 class="state__dvr">Total DVR:<span
                                                                    class="dvr__color"></span>{{data.totalDvrs}}</h6>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">CCTV Installed</h6>
                                                            <h5 class="cctv__number">
                                                                {{data.totalCamerasInstalled}}</h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">Connected</h6>
                                                            <h5 class="cctv__number">{{data.totalConnected}}
                                                            </h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">Not Connected</h6>
                                                            <h5 class="cctv__number">{{data.totalNotConnected}}
                                                            </h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">Streaming</h6>
                                                            <h5 class="cctv__number">
                                                                {{data.totalVideoStreaming}}</h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">No Video</h6>
                                                            <h5 class="cctv__number">
                                                                {{data.totalVideoNotStreaming}}</h5>
                                                        </div>
                                                        <div>
                                                            <!-- <a routerLink="/building/{{data.buildingId}}" h
                                                                ref="#"><button type="button"
                                                                    class="cctv_livebtn">Live</button></a> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-expansion-panel-header>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="cctv_video_show">
                                                        <ul class="video-image" *ngFor="let frame of data.cctvFrameURLList">
                                                            <li>
                                                                <div class="video_width">
                                                                        <button class="btn-1"
                                                                           
                                                                            (click)="openvideostreaming(frame)">
                                                                            <figure class="mb-0">
                                                                                <img [src]="frame.cctvFrameUrl"
                                                                                    class="cctvimg" alt="cctvimg missing">
                                                                            </figure>
                                                                            <p class="cctv_camno">C
                                                                                :{{frame.channelsNo}}
                                                                            </p>
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </div>
                                
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- =================== loader ==================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>